import { IModuleMeta } from '@/contracts/core/module/interface/IModuleMeta'
import { IApi } from '@/contracts/core/api/interface/IApi'
import { IModuleSocket } from '@/contracts/core/module/interface/IModuleSocket'
import { EnumViewType } from '@/contracts/core/module/enum/EnumViewType'
import { IZone } from '@/contracts/system-modules/share/IZone'

export default class implements IModuleMeta {
  getCode(): string {
    return 'libre'
  }
  registerApi(): IApi[] {
    return []
  }
  registerSocker(): IModuleSocket[] {
    return []
  }
  getZones(): IZone[] {
    return [{ code: 'libre.nodes', module: this.getCode(), title: 'Nodes' }]
  }
  viewTypes(): EnumViewType[] {
    return [
      EnumViewType.WINDOW,
      EnumViewType.WIDGET,
    ]
  }

  getParentId(): string {
    return 'common'
  }

  getModuleId(): string {
    return this.getCode() + '_' + this.getVersion()
  }

  getTitle(): string {
    return 'Libre'
  }

  getVersion(): string {
    return 'v1'
  }

  getIcon(): string {
    return 'flaticon-book'
  }
}
